import { FinnishSSN } from 'finnish-ssn';

export function validateFinnishSSN(ssn: string | undefined) {
  if (!ssn) return false;

  // Finnish national ids containing a "+" are for people born in 1800-1899. No
  // person in Finland is that old, so these SSNs should be considered invalid.
  // https://en.wikipedia.org/wiki/National_identification_number#Finland
  if (ssn.includes('+')) return false;

  return FinnishSSN.validate(ssn);
}

export function getAgeFromFinnishSSN(ssn: string | undefined) {
  if (!ssn) return;
  if (!FinnishSSN.validate(ssn)) return;
  const parsedSSN = FinnishSSN.parse(ssn);
  return parsedSSN.ageInYears;
}

export function getGenderFromFinnishSSN(ssn: string | undefined) {
  if (!ssn) return;
  if (!FinnishSSN.validate(ssn)) return;
  const parsedSSN = FinnishSSN.parse(ssn);
  return parsedSSN.sex;
}
